export default __webpack_public_path__ + "static/media/labPlan.57c023cc.jpeg";